exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ErrorBlock_message_1DdM {\n  position: relative;\n  padding: 30px 0;\n\n  text-align: center;\n}\n\n.ErrorBlock_icon_1gQA {}\n\n.ErrorBlock_text_2A4M {\n  margin-top: 10px;\n}\n\n.ErrorBlock_preloader_26-G {\n  visibility: hidden;\n}\n\n.ErrorBlock_isLoading_29US .ErrorBlock_message_1DdM {\n  visibility: hidden;\n}\n\n.ErrorBlock_isLoading_29US .ErrorBlock_preloader_26-G {\n  visibility: visible;\n}\n", ""]);

// exports
exports.locals = {
	"message": "ErrorBlock_message_1DdM",
	"icon": "ErrorBlock_icon_1gQA",
	"text": "ErrorBlock_text_2A4M",
	"preloader": "ErrorBlock_preloader_26-G",
	"isLoading": "ErrorBlock_isLoading_29US"
};